import { Container } from "@/components/layout";
import { LoadingState } from "@/components/ui";

export interface LoadingLayoutProps {
  message?: string;
}

export function LoadingLayout({
  message = "Loading HUDDL HQ…",
}: LoadingLayoutProps) {
  return (
    <Container>
      <LoadingState message={message} />
    </Container>
  );
}
